import { ApolloLink, Observable } from '@apollo/client'
import { useConnectionStatusStore } from 'stores/connectionStatusStore'

export const SLOW_REQUEST_THRESHOLD_MS = 4000

export const networkStatusLink = new ApolloLink((operation, forward) => {
  return new Observable(observer => {
    let isMarkedAsSlow = false

    const slowRequestTimer = setTimeout(() => {
      isMarkedAsSlow = true
      useConnectionStatusStore.getState().increaseSlowRequests()
    }, SLOW_REQUEST_THRESHOLD_MS)

    const releaseSlowRequest = () => {
      clearTimeout(slowRequestTimer)

      if (isMarkedAsSlow) {
        isMarkedAsSlow = false
        useConnectionStatusStore.getState().decreaseSlowRequests()
      }
    }

    const subscription = forward(operation).subscribe({
      next: result => observer.next(result),
      error: error => {
        releaseSlowRequest()
        observer.error(error)
      },
      complete: () => {
        releaseSlowRequest()
        observer.complete()
      }
    })

    return () => {
      releaseSlowRequest()
      subscription.unsubscribe()
    }
  })
})
